/**
 * @generated SignedSource<<c3f90d6baae0a12f66d16a686038e199>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "passwordConfirmation"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resetToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "passwordConfirmation",
        "variableName": "passwordConfirmation"
      },
      {
        "kind": "Variable",
        "name": "resetToken",
        "variableName": "resetToken"
      }
    ],
    "kind": "ScalarField",
    "name": "ResetPassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePasswordScreenMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePasswordScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6dfa167338fcba3e949bb821bfdee3de",
    "id": null,
    "metadata": {},
    "name": "UpdatePasswordScreenMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePasswordScreenMutation(\n  $password: String!\n  $passwordConfirmation: String!\n  $resetToken: String!\n) {\n  ResetPassword(password: $password, passwordConfirmation: $passwordConfirmation, resetToken: $resetToken)\n}\n"
  }
};
})();

node.hash = "f5ce2a3bc4ab126f4445e2f75e35d96b";

module.exports = node;
